export const sectorTypeLabels: Record<string, string> = {
  accommododationFood: "Accommodation and Food Services",
  adminSupport: "Administrative and Support Services",
  artsRecreation: "Arts and Recreation Services",
  construction: "Construction/Builder",
  education: "Education and Training",
  farming: "Farming, forestry and fishing",
  financial: "Financial Services & Insurance",
  government: "Government / Public Sector",
  manufacturing: "Manufacturing",
  medical: "Medical/Health Care/Community Services",
  personal: "Personal, Beauty, Wellbeing and other services",
  professional: "Professional Services (e.g. Legal, Accounting, Marketing, Consulting)",
  propery: "Property Operators and Real Estate Services",
  rental: "Rental & Hiring Services (non Real Estate)",
  repair: "Repair and Maintenance (Automotive & Property)",
  retailTradeFood: "Retail Trade (Food & Beverage)",
  retailTradeNonFood: "Retail Trade (Non-Food)",
  technology: "Technology/Telecommunications services",
  tradesWork: "Trades work (e.g. Plumber, Carpenter, Electrician)",
  tradeAssociation: "Trade Association, Association",
  transporLogistics: "Transport, Logistics, Postal, Warehousing",
  wholeTrade: "Whole Trade",
};

export const sectorModelLabels: Record<string, string> = {
  personalCompany: "Personal Company",
  limitedCompany: "Limited Liability Company",
  incorporatedCompany: "Incorporated Company",
  nongovernmental: "Non-Governmental Company",
  government: "Government",
};

export const formatSectorType = (value?: string | null): string =>
  (value && sectorTypeLabels[value]) || value || "";

export const formatSectorModel = (value?: string | null): string =>
  (value && sectorModelLabels[value]) || value || "";

export interface SelectOption {
  value: string;
  label: string;
}

const toOptions = (record: Record<string, string>): SelectOption[] =>
  Object.entries(record).map(([value, label]) => ({ value, label }));

export const sectorTypeOptions: SelectOption[] = toOptions(sectorTypeLabels);

export const sectorModelOptions: SelectOption[] = toOptions(sectorModelLabels);
